import { ButtonBg } from '@treedis/tour-loader';
import { TourType } from '@/_models/Tour';
import { toggleContactPopup } from '../util';
import DeviceManager from '../util/deviceManager';

export function renderButtonBg() {
  const { tour, room, menuOpen, host, translation, tourEmail, tourType, MenuHintOn, getInTouchHintOn, appointmentsHintOn } = this.state;
  const menuOpenForDevice = !!(DeviceManager.isMobile() ? tour.menuAlwaysOpenMobile : tour.menuAlwaysOpenDesktop);
  const showExpand = !this.state.menuOpened && !tour.menuOnStart;
  const showCustomButton = tour.customButton && tour.customButtonIcon && tourType === TourType.Regular;

  return (
    <>
      <ButtonBg
        chatToken={room}
        menu={{ menuEnabled: tour.menuEnabled } as any}
        toggleNav={this.toggleNav.bind(this)}
        handleCustomButton={this.handleCustomButton}
        showExpand={showExpand}
        toggleAppointmentsModal={this.toggleAppointmentsModal}
        appointmentsHintOn={appointmentsHintOn}
        toggleContactPopup={toggleContactPopup.bind(this)}
        tourEmail={tourEmail}
        getInTouchHintOn={getInTouchHintOn}
        MenuHintOn={MenuHintOn}
        showCustomButton={showCustomButton}
        translation={translation}
        tourType={tourType}
        menuOpen={menuOpen}
        tour={tour}
        host={host}
        menuOpenForDevice={menuOpenForDevice}
      />
      {this.injectBottomBg()}
    </>
  );
}
